export function numberToCurrency(number) {
  if (number === null || number === undefined) {
    return ''; // Ou qualquer valor padrão que você desejar retornar para um valor nulo
  }

  const options = {
    style: "currency",
    currency: "BRL",
  };

  return number.toLocaleString("pt-BR", options);
}


export function cleanCurrencyValue(formattedValue: string): string {
  return formattedValue
    .replace(/R\$\s?/g, "")     // Remove R$ com ou sem espaço
    .replace(/\./g, "")         // Remove pontos (separadores de milhares)
    .replace(/,/g, ".")         // Substitui vírgula por ponto (decimal)
    .trim();                    // Remove espaços extras
}